// import axios from 'axios'
import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { schemaDevice, schemaDeviceSimple, formatDevicePagi } from '../schemas'
import axios from 'axios'

/**
 * 新增设备
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 设备名称
 * @param {*String} options.snHexadecimal 十六进制的sn号
 * @param {*String} options.pnHexadecimal 十六进制的pn号
 * @param {*Number} options.lng 经度
 * @param {*Number} options.lat 纬度
 * @param {*Number} options.paramSettingMode 参数设置模式,1-默认；2-自定义（如果电池电压选其他此参数值则为2-自定义，否则为1-默认）
 * @param {*Number} options.batteryType 电池类型（1-磷酸铁锂；2-三元锂；3-铅酸；）
 * @param {*Number} options.batteryVoltage 电池电压（如电池类型选中磷酸铁锂有12V，24V，其他）
 * @param {*Number} options.batteryOverVoltage 电池超压电压（用于充电停止电压），单位：V
 * @param {*Number} options.batteryOverToBackVoltage 电池超压恢复电压，单位：V
 * @param {*Number} options.batteryLowVoltage 电池低压电压（用于停止亮灯电压），单位：V
 * @param {*Number} options.batteryLowToBackVoltage 电池低压恢复电压，单位：V
 * @param {*Number} options.ledRatedCurrent LED灯额定电流，单位：A
 * @param {*Number} options.dayThreshold 光控天亮阈值，单位：V
 * @param {*Number} options.nightThreshold 光控天黑阈值，单位：V
 * @param {Number} options.strongChargeVoltage 强充电压，单位：V
 * @param {Number} options.evenChargeVoltage 均衡充电压，单位：V
 * @param {Number} options.floatChargeVoltage 浮充电压，单位：V
 */
export const create = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = 'v2/solar-motes/activated'
  if (productId === '16' || (options.isExclusive && productId === '-1')) {
    path = `repower/${path}`
  }
  const { data: { detail } } = await axios.post(`${path}?projectId=${options.projectId}`, options)
  const { entities } = normalize(detail, schemaDevice)
  return fromJS(entities)
}

/**
 * 删除设备
 * @param {*String} deviceId 设备id
 */
export const destroyById = async (deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = 'v2/solar-motes/set-unactivated/'
  if (productId === '16') {
    path = `repower/${path}`
  }
  await axios.delete(`${path}${deviceId}`)
}

/**
 * 修改设备
 * @param {*String} options.id 设备id
 * @param {*String} options.name 设备名称
 * @param {*Number} options.lng 经度
 * @param {*Number} options.lat 纬度
 */
export const updateById = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = 'v2/solar-motes'
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data: { detail } } = await axios.put(`${path}/${options.id}`, options)
  const { entities } = normalize(detail, schemaDevice)
  return fromJS(entities)
}

/**
 * 获取设备列表，跨项目的，个人所有项目所有设备，简要信息
 * @param {String} projectId 项目id
 */
export const findAll = async (projectId) => {
  let path = 'v2/solar-motes/brief'
  if (projectId) {
    path += `/${projectId}`
  }
  const { data } = await axios.get(path)
  const { entities } = normalize(data, [ schemaDeviceSimple ])
  return fromJS(entities)
}

/**
 * 获取设备列表
 * @param {*String} options.projectId 项目id
 */
export const find = async (options) => {
  const { projectId } = options
  let productId = sessionStorage.getItem('productType')
  let path = 'v2/solar-motes'
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      projectId
    }
  })
  const { entities } = normalize(data, [ schemaDevice ])
  return fromJS(entities)
}

/**
 * 查询设备列表分页
 * @param {*String} options.projectId 项目id
 * @param {*String} options.pageNo 当前页
 * @param {*String} options.pageSize 每页条数
 * @param {String} options.isDisabled 是否过滤停用设备 true, false
 * @param {String} options.name 设备名称
 * @param {String} options.statusType 按状态查询的条件
 * @param {String} options.gruopId 分组id
 */
export const findByPagi = async (options) => {
  const { projectId, pageNo, pageSize, isDisabled, name, statusType, groupId, createStartDate, createEndDate } = options
  let productId = sessionStorage.getItem('productType')
  let path = 'v2/solar-motes/pagi'
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      projectId,
      pageNo,
      pageSize,
      isDisabled,
      name,
      statusType,
      groupId,
      createStartDate,
      createEndDate
    }
  })
  return formatDevicePagi(data)
}
export const findByPagi2 = async (options) => {
  const { projectId, pageNo, pageSize, isDisabled, name, statusType, groupId } = options
  let productId = sessionStorage.getItem('productType')
  let path = 'v1/solar-mote-pay/find-page'
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      projectId,
      pageNo,
      pageSize,
      isDisabled,
      name,
      statusType,
      groupId
    }
  })
  return formatDevicePagi(data)
}
/**
 * 获取分组内的设备id列表
 * @param {*String} options.projectId 项目id
 * @param {*String} options.groupId 分组id
 */
export const findIdsInGroup = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-mote-groups/${options.groupId}/mote-ids`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path)
  return fromJS(data.map(item => item.toString()))
}

/**
 * 获取设备信息和状态
 * @param {*String} deviceId 设备id
 */
export const findById = async (deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/get-info-and-status/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path)
  const { entities } = normalize(data, schemaDevice)
  return fromJS(entities)
}

/**
 * 获取项目告警设备
 * @param {*String} options.projectId 项目id
 */
export const findDevicesInAlerts = async (options) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { projectId, statusType, isDisabled } = options
  const { data } = await axios.get(path, {
    params: {
      projectId,
      statusType,
      isDisabled
    }
  })
  return data
}

/**
 * 获取设备告警信息
 * @param {*String} deviceId 设备id
 * @param {*Number} options.pageNo 当前页
 * @param {*Number} options.pageSize 每页条数
 * @param {String} options.isRead 搜索的告警状态是否是已读（1 查询已读;0 查询未读;null 查询全部）
 */
export const findAlertsById = async (options) => {
  const { deviceId, pageNo, pageSize, isRead } = options
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/list-mote-alert/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      isRead,
      pageNo,
      pageSize
    }
  })
  return data
}

/**
 * 处理设备
 * @param {*String} deviceId 设备id
 */
export const disposeById = async (deviceId) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/processed/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.put(path)
  return data
}

/**
 * 获取产品参数列表
 */
export const findParams = async () => {
  const { data } = await axios.get(`v2/product-params`)
  return data
}

/**
 * 获取产品参数列表
 */
export const findParams1 = async () => {
  const { data } = await axios.get(`repower/v2/product-params`)
  return data
}

/**
 * 获取设备扩展属性列表
 */
export const findOptionsList = async () => {
  const { data } = await axios.get(`v2/solar-mote-options/list`)
  return data
}

/**
 * 删除属性标记
 * @param {*String} markId 标记id
 */
export const destroyOptionById = async (markId) => {
  await axios.delete(`v2/solar-mote-options/${markId}`)
}

/**
 * 获取设备扩展属性列表
 * @param {*String} options.markId 标记id
 * @param {*String} options.productType 产品类型；1-人体感应；2-市电互补；3-开关控制器
 */
export const updateOptionById = async (options) => {
  await axios.put(`v2/solar-mote-options/${options.markId}`, options)
}

/**
 * 激活校验SN号
 */
export const checkSnType = async (snHex) => {
  let {data} = await axios.post(`v2/solar-motes/check-activated?snHex=${snHex}`)
  return data
}

/**
 * 获取基站信息
 */
export const getPostionInfo = async (deviceId) => {
  let {data} = await axios.post(`v1/device-downs/get-site-position/${deviceId}`)
  return data
}

/**
 * 批量基站定位
 */
export const getPositionInfoBatch = async (projectId, solarMoteIds) => {
  let {data} = await axios.post(`v1/device-downs/get-site-position-batch?projectId=${projectId}`, { solarMoteIds })
  return data
}
